var map = {
	"./part1/voice/question1_au.mp3": "c489",
	"./part1/voice/question1_en.mp3": "52b6",
	"./part1/voice/question2_au.mp3": "8842",
	"./part1/voice/question2_en.mp3": "2338",
	"./part1/voice/question3_au.mp3": "f452",
	"./part1/voice/question3_en.mp3": "5268",
	"./part1/voice/question4_au.mp3": "7dd8",
	"./part1/voice/question4_en.mp3": "e32f",
	"./part2/voice/question10_au.mp3": "3f71",
	"./part2/voice/question10_en.mp3": "91ec",
	"./part2/voice/question11_au.mp3": "3913",
	"./part2/voice/question11_en.mp3": "9d32",
	"./part2/voice/question12_au.mp3": "d916",
	"./part2/voice/question12_en.mp3": "091c",
	"./part2/voice/question1_au.mp3": "b97f",
	"./part2/voice/question1_en.mp3": "3505",
	"./part2/voice/question2_au.mp3": "cc96",
	"./part2/voice/question2_en.mp3": "457d",
	"./part2/voice/question3_au.mp3": "d86b",
	"./part2/voice/question3_en.mp3": "45f2",
	"./part2/voice/question4_au.mp3": "1025",
	"./part2/voice/question4_en.mp3": "8bf5",
	"./part2/voice/question5_au.mp3": "48f7",
	"./part2/voice/question5_en.mp3": "c45d",
	"./part2/voice/question6_au.mp3": "40d8",
	"./part2/voice/question6_en.mp3": "85bf",
	"./part2/voice/question7_au.mp3": "fdf4",
	"./part2/voice/question7_en.mp3": "02cb",
	"./part2/voice/question8_au.mp3": "5bef",
	"./part2/voice/question8_en.mp3": "e900",
	"./part2/voice/question9_au.mp3": "94ed",
	"./part2/voice/question9_en.mp3": "0388",
	"./part3/voice/question1_au.mp3": "131d",
	"./part3/voice/question1_en.mp3": "4437",
	"./part3/voice/question2_au.mp3": "6033",
	"./part3/voice/question2_en.mp3": "cf22",
	"./part3/voice/question3_au.mp3": "18dc",
	"./part3/voice/question3_en.mp3": "9923",
	"./part3/voice/question4_au.mp3": "90a4",
	"./part3/voice/question4_en.mp3": "ac10",
	"./part4/voice/question1_au.mp3": "4e3a",
	"./part4/voice/question1_en.mp3": "34ba",
	"./part4/voice/question2_au.mp3": "a55b",
	"./part4/voice/question2_en.mp3": "631a",
	"./part4/voice/question3_au.mp3": "fb96",
	"./part4/voice/question3_en.mp3": "affc",
	"./part4/voice/question4_au.mp3": "851a",
	"./part4/voice/question4_en.mp3": "ed23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06cb";